import React from 'react';
import PlayerInfoTitle from '@smart-tv/components/player/player-info-title';
import PlayerInfo from '../../player-info';
import useStream from '../../_hooks/use-stream';
import PlayerInfoSubtitle from '../../player-info-subtitle';

export const VodPlayerScreenInfo = () => {
  const { streamTitles } = useStream();

  return (
    <PlayerInfo>
      <PlayerInfoTitle>{streamTitles?.title}</PlayerInfoTitle>
      <PlayerInfoSubtitle>{streamTitles?.subtitle}</PlayerInfoSubtitle>
    </PlayerInfo>
  );
};

export default React.memo(VodPlayerScreenInfo);
